/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentThread } from '../models/DocumentThread';
import type { DocumentThreadCreate } from '../models/DocumentThreadCreate';
import type { DocumentThreadUpdate } from '../models/DocumentThreadUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DocumentThreadService {

    /**
     * Update
     * @param requestBody
     * @returns DocumentThread Successful Response
     * @throws ApiError
     */
    public static updateApiV1DocumentthreadPut(
        requestBody: DocumentThreadUpdate,
    ): CancelablePromise<DocumentThread> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/documentthread',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create
     * @param requestBody
     * @returns DocumentThread Successful Response
     * @throws ApiError
     */
    public static createApiV1DocumentthreadPost(
        requestBody: DocumentThreadCreate,
    ): CancelablePromise<DocumentThread> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/documentthread',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
